
export default {
  name: 'ProductOptions',
  props: {
    product: {
      type: Object,
      default: null
    },
    availability: {
      type: Boolean,
      default: true
    }
  },
  vessel: {
    label: {
      fontWeight: 'semibold'
    }
  },
  watch: {
    product: {
      immediate: true,
      handler(value) {
        if (value) {
          this.generateInputs(value)
        }
      }
    }
  },
  data() {
    return {
      model: {},
      inputs: []
    }
  },
  methods: {
    setVariant() {
      const form = this.$refs.form
      const formValue = form ? form.value : this.model

      const variant = this.product.variants.find(({ options }) => {
        return Object.entries(formValue).every(([key, value]) => {
          const opt = options.find(o => o.internalName == key)
          return opt && opt.value == value
        })
      })

      this.$emit('set-variant', variant)
    },
    updateValues(selected, inputName) {
      const form = this.$refs.form
      const filtered = {}

      const hasValue = (opt) => opt.internalName == inputName && opt.value == selected
      const variants = this.product.variants.filter(v => v.options.find(hasValue))
      const options  = variants.reduce((all, { options }) => [...all, ...options], [])

      options.forEach(({ internalName, value }) => {
        const values = filtered[internalName] || []

        if (!values.includes(value)) {
          filtered[internalName] = [...values, value]
        }
      })

      Object.keys(filtered).forEach(option => {
        if (option !== inputName) {
          const input = this.inputs.find(i => i.$prop == option)
          const valid = filtered[option]
          const active = input.$activeOptions.filter(({ value }) => valid.includes(value))

          active.forEach(item => {
            const hasValue = (opt) => opt.label == item.label && opt.value == item.value
            const variant = variants.find(v => v.options.find(hasValue))

            item.quantity = variant.totalOnHand
            item.disabled = this.product.backorderable ? false : variant.totalOnHand == 0
          })

          input.$options = active

          if (input.$el.options) {
            input.$el.options = active
          }

          if (form) {
            const formValue = form.value[option]

            if (!active.some(({ value }) => value == formValue)) {
              const newValue = active.find(({ disabled }) => disabled == false)

              form.updateValue({ id: option, value: newValue.value })
            }
          }
        }
      })
    },
    generateInputs(product) {
      if (!this.product.options) return

      const items = []
      const model = {}

      const allValues = this.product.variants.reduce((all, { options }) => {
        options.forEach(({ internalName, value }) => {
          const values = all[internalName] || []

          if (!values.includes(value)) {
            all[internalName] = [...values, value]
          }
        })

        return all
      }, {})

      const types = {
        'TEXT': { type: 'select', tag: 'OptionSelect' },
        'NUMBER': { type: 'radio-group' },
        'COUNTRY': { type: 'select', tag: 'OptionSelect' },
        'LENGTH': { type: 'select', tag: 'OptionSelect' },
        'WEIGHT': { type: 'select', tag: 'OptionSelect' },
        'VOLUME': { type: 'select', tag: 'OptionSelect' },
        'COLOR': { type: 'input', tag: 'ColorOptions' }
      }

      product.options.forEach(option => {
        const { internalName, kind, values, name } = option

        const optionValues = allValues[internalName] || []
        const options = values.filter(({ value }) => optionValues.includes(value))

        if (!options.length) {
          return
        }

        if (product.options.length == 1) {
          options.forEach(opt => {
            const hasValue = (varOpt) => varOpt.label == opt.label && varOpt.value == opt.value
            const variant = product.variants.find(v => v.options.find(hasValue))

            opt.quantity = variant.totalOnHand
            opt.disabled = product.backorderable ? false : variant.totalOnHand == 0
          })
        }

        const type = types[kind]['type'] || 'select'
        const tag = types[kind]['tag']
          ? require(`../inputs/${types[kind]['tag']}`).default
          : null

        model[internalName] = options[0].value

        const input = {
          $type: type,
          $id: internalName,
          $tag: tag,
          $prop: internalName,
          $options: options,
          $activeOptions: options,
          $el: {
            placeholder: name,
            options: options,
            availability: this.availability
          },
          $attrs: {
            title: name,
          },
          on: {
            input: (value) => {
              this.updateValues(value, internalName)
            }
          }
        }

        items.push(input)
      })

      this.model = model
      this.inputs = items

      items.forEach(input => {
        this.updateValues(input.$options[0].value, input.$prop)
      })

      this.setVariant()
    }
  }
}
